import { useContext } from 'react';

import { QualificationContext } from '../../../qualification-context';

const useSegments = (selectedSegments) => {
  const { categories: segmentsOptions } = useContext(QualificationContext);

  const getSelectedSegmentsLabel = (segmentKey) => {
    const segmentItem = segmentsOptions.find((option) => option.key === segmentKey);

    return segmentItem.label.toLowerCase();
  };

  const filterSelectedSegments = (condition) =>
    selectedSegments.filter(condition).map(getSelectedSegmentsLabel).sort();

  const qualifiedSegmentsLabels = filterSelectedSegments((segmentKey) =>
    segmentsOptions.find((item) => item.key === segmentKey && item.is_valid)
  );
  const unqualifiedSegmentsLabels = filterSelectedSegments((segmentKey) =>
    segmentsOptions.find((item) => item.key === segmentKey && !item.is_valid)
  );

  return {
    qualifiedSegmentsLabels,
    unqualifiedSegmentsLabels,
  };
};

export default useSegments;
